/* eslint-disable react/prop-types */
import clsx from 'clsx'
import type { NumberCell } from '../types'
import { createRenderer } from './renderer'
import { Input, Popover, PopoverContent, PopoverTrigger } from '../../../shadcn'
import { NOL } from './null'
import { EditorFooter } from './utils'
import { useCallback } from 'react'

export const NumberRenderer = createRenderer<NumberCell>({
  View: ({ className, cell }) => {
    return (
      <div className={clsx(className, 'focus-within:outline-none', { 'computed-cell': cell.computed })}>
        {cell.content ?? cell.value ?? <NOL />}
      </div>
    )
  },
  Editor: ({ className, cell, onCellChange, ...props }) => {
    const handleSave = useCallback(() => {
      props.onClose(true)
    }, [props.onClose])

    return (
      <Popover open={true}>
        <PopoverTrigger className="w-full h-full pl-2">
          <div
            className={clsx(className, 'focus-within:outline-none text-left', {
              'computed-cell': cell.computed,
            })}
          >
            {cell.content ?? cell.value ?? <NOL />}
          </div>
        </PopoverTrigger>
        <PopoverContent className="p-0 border-none w-[180px]">
          <Input
            type="number"
            placeholder="Enter number..."
            className="ps-1 w-full pl-2 outline-none focus-visible:ring-0 resize-none focus:outline-none rounded-b-none"
            value={cell.value ?? undefined}
            onChange={(e) =>
              onCellChange?.(props.row, {
                type: 'number',
                value: e.target.value ? parseFloat(e.target.value) : null,
              })
            }
          />
          <EditorFooter handleSave={handleSave} />
        </PopoverContent>
      </Popover>
    )
  },
})
